'use client';

import { cn } from '@coas/ui/lib';
import { memo } from 'react';
import IconTrash from 'src/shared/assets/icons/trash.svg';
import { useRemoveAllFromCart } from '../model/mutations';

type RemoveFromCartProps = {
    productPriceId: string;
    className?: string;
};

export default memo(({ productPriceId, className }: RemoveFromCartProps) => {
    const { mutate: remove } = useRemoveAllFromCart();

    return (
        <button
            type={'button'}
            className={cn('outline-offset-2 outline-neutral-500 focus-visible:outline', className)}
            onClick={() => remove({ productPriceId })}
        >
            <IconTrash className={'h-full w-full stroke-neutral-500'} />
        </button>
    );
});
